const api = '/api/v1/item.php';
import axios from 'axios';
export const itemRepository =  {
    methods: {
        async register(item){
            return  axios.post(api,item)
        },
        async getAll(){
            return  axios.get('/api/v1/item2.php');
        },
        async getAllImg(){
            return  axios.get(api,{
                params: {
                AllImg:true
              }});
        },
        async getPage(pageNume){
            return  axios.get('/api/v1/itemPage.php',{
                params: {
                PAGE_NUM:pageNume
              }});
        },
        async getOne(itemId){
            return  axios.get(api,{
                params: {
                ITEM_ID:itemId
              }});
        },
        async getItemCount(){
            return  axios.get('/api/v1/itemCount.php');
        }
    }
};

